import React, { useEffect } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import theme from "./theme";
import { useAuthStore } from "./stores/authStore";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { HelmetProvider } from "react-helmet-async";
// Pages
import { Home } from "./components/Home";
import { Usage } from "./pages/dashboard/Usage";
import { Settings } from "./components/Settings";
import { Pricing } from "./components/Pricing";
// import { Contact } from "./components/Contact";
import { NotFound } from "./components/NotFound";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { TermsOfService } from "./components/TermsOfService";
import { AccountDeletion } from "./components/AccountDeletion";

// Auth Pages
import { Login } from "./components/Login";
import { Register } from "./components/Register";
import { AuthSuccess } from "./components/AuthSuccess";

// Payment Pages
import { AddFunds } from "./components/payments/AddFunds";
import { SwitchPlan } from "./components/payments/SwitchPlan";
import { Payments } from "./components/payments/Payments";

// Profile
import { Profile } from "./components/profile/Profile";
import { Affiliate } from "./pages/affiliate/Affiliate";

// Chat
import { ChatInterface } from "./components/ChatInterface";
import "./i18n/config";

import { ForgotPassword } from "./components/ForgotPassword";
import { ResetPassword } from "./components/ResetPassword";
import { VerifyEmail } from "./components/VerifyEmail";
import { Support } from "pages/support/Support";
import { TicketDetail } from "pages/support/TicketDetail";
import { Admin } from "components/Admin";
import { Features } from "pages/features/Features";
import { Soon } from "components/Soon";
import { ScrollToTop } from "./components/ScrollToTop";
import { Contact } from "components/Contact";
import { Dashboard } from "components/Dashboard";
import { Agents } from "pages/agent/Agents";
import { EditAgent } from "pages/agent/EditAgent";
import { Characters } from "pages/character/Characters";
import { EditCharacter } from "pages/character/EditCharacter";
import { Subuser } from "pages/subuser/Subuser";
import { EditSubuser } from "pages/subuser/EditSubuser";
// import { SubUsers } from "components/SubUsers";
import { Nuvemshop } from "components/Nuvemshop";
import { Chatbot } from "components/Chatbot";
import { Models } from "components/Models";
function App() {
  const subdomain = window.location.hostname.startsWith("nuvemshop.");
  console.log({ subdomain });
  const loadUser = useAuthStore((state) => state.loadUser);

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_path: window.location.pathname + window.location.search,
    });
    loadUser();
  }, [loadUser]);

  return (
    <HelmetProvider>
      <ChakraProvider theme={theme}>
        <Router>
          {subdomain ? <Navigate to="/nuvemshop" replace /> : null}
          <ScrollToTop />
          <Routes>
            {/* {subdomain && (
              <Route path="*" element={<Navigate to="/nuvemshop" replace />} />
            )} */}
            <Route path="/" element={<Home />} />
            <Route path="/nuvemshop" element={<Nuvemshop />} />
            <Route path="/chat-agents" element={<Chatbot />} />
            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/success" element={<AuthSuccess />} />

            {/* Public Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/account-deletion" element={<AccountDeletion />} />

            {/* Dashboard Routes */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/agents/:id" element={<EditAgent />} />
            <Route path="/characters" element={<Characters />} />
            <Route path="/characters/:id" element={<EditCharacter />} />
            <Route path="/subusers" element={<Subuser />} />
            <Route path="/subusers/:id" element={<EditSubuser />} />
            <Route path="/chat/:sessionId?" element={<ChatInterface />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/soon" element={<Soon />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/models" element={<Models />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/usage" element={<Usage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/affiliate" element={<Affiliate />} />
            <Route path="/features" element={<Features />} />
            {/* Payment Routes */}
            <Route path="/payments" element={<Payments />} />
            <Route path="/payments/add-funds" element={<AddFunds />} />
            <Route path="/payments/switch-plan" element={<SwitchPlan />} />

            {/* Support Routes */}
            <Route path="/support" element={<Support />} />
            <Route path="/support/:id" element={<TicketDetail />} />
            {/* 404 Route - Keep this last */}
            <Route path="*" element={<NotFound />} />

            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Routes>
          {/* <AppContent /> */}
        </Router>
        <Analytics />
        <SpeedInsights />
      </ChakraProvider>
    </HelmetProvider>
  );
}

// New component to handle location-based effects
function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Prevent body scroll on chat routes
    if (location.pathname.startsWith("/chat")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [location.pathname]);

  return null;
}

export default App;
